<template>
  <div>
    <p class="cm-mg-p-wzd">2.1 {{ $t('diseases.symptoms_info') }}</p>
    <hr />
    <div class="row">
      <div class="form-group has-label col-12 col-md-6 col-lg-4">
        <label class="text-transform-none"
          >{{ $t('diseases.symptoms_number') }}:</label
        >
        <br />
        <fg-input
          clearable
          type="Number"
          v-model.number="model.symptoms_number"
          name="diseases.symptoms_number"
          v-validate="modelValidations.symptoms_number"
          :error="getError('diseases.symptoms_number', true)"
          :placeholder="`${$t('common_words.enter')}...`"
          :limit="20"
          :max="20"
        >
        </fg-input>
      </div>
    </div>
    <div v-if="this.model.symptoms_number > 0">
      <span v-for="i in model.symptoms_number" :key="'symptom' + i">
        <div class="row">
          <div class="col-6">
            <div class="form-group has-label">
              <div class="col-8">
                <label class="text-transform-none"
                  >{{ $t('diseases.symptom') }}:</label
                >
                <fg-input
                  clearable
                  type="text"
                  v-model="model.symptom_names[i - 1]"
                  :placeholder="`${$t('diseases.symptom')}...`"
                  @change="formatFirstLetterUppercase('symptom_names', [i - 1])"
                >
                </fg-input>
              </div>
            </div>
          </div>
        </div>
      </span>
    </div>
    <p class="cm-mg-p-wzd">2.2 {{ $t('diseases.symptoms_info') }}</p>
    <hr />
    <div class="row">
      <div class="form-group has-label col-12 col-md-6 col-lg-4">
        <label class="text-transform-none"
          >{{ $t('common_words.type') }}: *</label
        >
        <br />
        <el-select
          clearable
          class="select-primary custom-width-select shadow-sm required-disease"
          v-model="model.catch_type"
          filterable
          :placeholder="`${$t('common_words.select')}...`"
          @change="getNameDisease()"
        >
          <el-option
            class="select-primary"
            value="1"
            :label="$t('common_words.status_or_level')"
          >
          </el-option>
          <el-option
            class="select-primary"
            value="2"
            :label="$t('common_words.normal')"
          >
          </el-option>
        </el-select>
      </div>
      <fg-input
        class="col-12 col-md-6 col-lg-4"
        type="number"
        :label="`${$t('common_words.levels_or_status_number')}: *`"
        v-model.number="model.level_number"
        name="common_words.levels_or_status_number"
        v-validate="modelValidations.level_number"
        :error="getError('common_words.levels_or_status_number', true)"
        placeholder="3"
        min="0"
        :limit="20"
        @change="updateArrays()"
      ></fg-input>
    </div>
    <br />
    <div class="row" v-if="model.catch_type == 1">
      <div class="col-12 col-md-6 col-lg-4">
        <fg-input
          :label="$t('common_words.level_or_status')"
          v-model="model.init_level"
          type="number"
          disabled
          min="0"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <div class="form-group">
          <fg-input
            class="required-init_name_lavel"
            :label="`${$t('common_words.level_or_status_name')}: *`"
            v-model="model.init_name_lavel"
            type="text"
            @change="formatFirstLetterUppercase('init_name_lavel')"
          ></fg-input>
        </div>
      </div>
    </div>
    <div v-if="model.catch_type == 1">
      <div class="row" v-for="index in model.level_number" :key="index + 'ln'">
        <div class="col-12 col-md-6 col-lg-4">
          <fg-input
            :class="`required-number_level${
              index - 1
            }`"
            v-model.number="model.number_level[index - 1]"
            type="number"
            :label="`${$t('common_words.indicator_number')}: *`"
            placeholder="1"
            @change="validateExistData(model.number_level[index - 1], 1)"
            :disabled="model.disabled[index - 1]"
            min="0"
          ></fg-input>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <fg-input
            :class="`required-name_level${
              index - 1
            }`"
            v-model="model.name_level[index - 1]"
            type="text"
            :label="`${$t('common_words.level_or_status_name')}: *`"
            @change="handleChange([index - 1], 2)"
            :placeholder="`${$t('common_words.level')}...`"
          ></fg-input>
        </div>
        <div class="col-12 col-lg-4 mt-4">
          <el-upload
            :id="'diseaselevelimage' + index"
            :data="getLevelId(index)"
            :headers="headerInfo"
            class="upload-demo custom-upload upload-image-level"
            :action="
              getAxiosURL() + '/auth/diseases/diseases/uploaddiseaselevelimage'
            "
            :before-upload="emitImg"
            :limit="1"
            :file-list="model.fileList[index - 1]"
            :on-preview="handlePreview"
            :on-remove="handleRemoveIMG.bind(this, index)"
            :on-exceed="handleExceed"
            :on-success="handleSuccess.bind(this, index)"
          >
            <el-button size="small" type="success">{{
              $t('common_words.upload_image')
            }}</el-button>
          </el-upload>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { convertFirstLetterUppercase } from 'src/util/Util.js';
import { isset } from 'src/util/Util.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      model: {
        id: null,
        catch_type: null,
        level_number: null,
        init_level: 0,
        init_name_lavel: 'Sin aparición de la enfermedad',
        number_level: [],
        name_level: [],
        disabled: [],
        fileList: [],
        symptom_names: [],
        symptom_ids: [],
        symptoms_number: null,
      },
      modelValidations: {
        level_number: {
          required: true,
          min_value: 0,
        },
        symptoms_number: {
          min_value: 0,
        },
      },
      lengthInitial: 0,
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters, MixinValidations],
  methods: {
    handleRemoveIMG(index, file) {
      // this.uploadData.nameFile = file.name;
      this.$emit('emitDelete', file.name);
      this.removeIMGUpload(file, index);
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } { i18n.t('sweet_alert.ground.files')} `
      );
    },

    handlePreview($event){
      const link = document.createElement("a");
      if(this.model.id !== null){
        link.href = `${BASE_URL}smart-backend/path_images/diseasesfiles/${this.model.id}/${$event.name}`;
      }else{
        link.href = `${BASE_URL}smart-backend/path_images/diseasesfiles/tmp/${this.$store.state.auth.user.id}/${$event.name}`;

      }
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
    },

    handleSuccess(index, res, file) {
      if (res == 'extensión no valida') {
        SweetAlert.warning(i18n.t('sweet_alert.disease.invalid_file'));

        return false;
      }

      return true;
    },

    verifyUpload(file) {
      this.showHideLoading(true);
      const isIMG = ['.png', '.jpg', '.jpeg', '.svg'].some((el) =>
        file.name.includes(el)
      );
      if (!isIMG) {
        SweetAlert.warning(i18n.t('sweet_alert.disease.invalid_file'));

        setTimeout(() => {
          this.$forceUpdate();
        }, 100);

        localStorage.setItem('listFiles', JSON.stringify(this.model.fileList));
        this.showHideLoading();
      }
      this.showHideLoading();

      return isIMG;
    },

    removeIMGUpload(file, index) {
      this.showHideLoading(true);
      let levelID = this.getLevelId(index);
      Axios.postMasters({
        route: 'diseases/diseases/deleteimg',
        name: file.name,
        user: this.$store.state.auth.user.id,
        diasese_status_id: levelID,
      }).then((response) => {
        this.showHideLoading();
        this.model.fileList[index] = null;
        localStorage.setItem('listFiles', JSON.stringify(this.model.fileList));
      });
    },

    getNameDisease() {
      if (this.model.catch_type == 1 && !sessionStorage.getItem('editForm'))
        this.$emit('getNameDiseaseDigit');
    },

    emitImg(img) {
      let verified = this.verifyUpload(img);
      if (verified) {
        this.$emit('setImgsToMove', img.name);
      } else {
        return false;
      }
    },

    emitDelete(img) {
      this.$emit('deleteToMove', img.name);
    },

    getLevelId(index) {
      let editForm = JSON.parse(sessionStorage.getItem('editForm'));
      if (editForm && editForm['disease_statuses'].length > 0) {
        let obj = {
          disease_id: editForm.id,
          user: this.$store.state.auth.user.id,
        };

        if (index <= editForm['disease_statuses'].length - 1) {
          obj['disease_level_id'] = editForm['disease_statuses'][index].id;
        } else {
          obj['disease_level_id'] = null;
        }

        return obj;
      }

      return {
        disease_id: null,
        disease_level_id: null,
        user: this.$store.state.auth.user.id,
      };
    },

    handleChange(index, option) {
      this.formatFirstLetterUppercase('name_level', index);
      this.validateExistData(this.model.name_level[index], option);
    },    
 
    formatFirstLetterUppercase(key, idx = null) {
      if (idx !== null) {
        const value = this.model[key][idx];
        this.model[key][idx] = convertFirstLetterUppercase(value);
      } else {
        const value = this.model[key];
        this.model[key] = convertFirstLetterUppercase(value);
      }
    },

    validateExistData(data, option) {
      let response = false;
      switch (option) {
        case 1:
          response = this.validateRepeated(this.model.number_level);
          break;
        case 2:
          response = this.validateRepeated(this.model.name_level);
          break;
      }

      if (response) {
        SweetAlert.warning(
          i18n.t('sweet_alert.disease.value_field_exist') +
            (option == 1
              ? i18n.t('common_words.indicator_number')
              : i18n.t('common_words.level_or_status_name'))
        );
      }
    },

    validateRepeated(lista) {
      let a = 0;
      let b = 0;
      let c = 0;
      let d = 0;
      let num = 0;

      while (a < lista.length) {
        b = lista[a];
        if (typeof b === 'string') b = b.trim();
        c = 0;
        while (c < lista.length) {
          d = lista[c];
          if (typeof d === 'string') d = d.trim();
          if (b === d) {
            num++;
          }

          if (num > 1) {
            return true;
          }

          c++;
        }

        a++;
        num = 0;
      }

      return false;
    },

    updateArrays() {
      let ln = this.model.number_level.length - this.model.level_number;
      if (ln > 0) {
        if (
          ln == 1 &&
          (this.model.level_number > this.lengthInitial ||
            (this.model.level_number == this.lengthInitial &&
              this.model.number_level.length > this.lengthInitial))
        ) {
          this.model.number_level.pop();
          this.model.name_level.pop();
        } else if (ln > 1) {
          this.model.number_level.splice(this.lengthInitial, ln);
          this.model.name_level.splice(this.lengthInitial, ln);
        }
      }

      this.model.number_level = [];

      for (let index = 1; index <= this.model.level_number; index++) {
        this.model.number_level.push(index);
      }
    },

    validate() {
      let elThis = this;

      if (elThis.validateRepeated(this.model.number_level)) {
        SweetAlert.warning(
          i18n.t('sweet_alert.disease.indicator_field_exists')
        );

        return false;
      }

      if (elThis.validateRepeated(this.model.name_level)) {
        SweetAlert.warning(i18n.t('sweet_alert.disease.name_field_exists'));

        return false;
      }

      return this.$validator
        .validateAll()
        .then((res) => {
          if (this.model.catch_type == 2) {
            this.model.number_level = [];
            this.model.name_level = [];
          }

          if (this.model.level_number < this.lengthInitial) {
            this.model.number_level.splice(
              this.model.level_number,
              this.lengthInitial - this.model.level_number
            );
            this.model.name_level.splice(
              this.model.level_number,
              this.lengthInitial - this.model.level_number
            );
          }

          if (!isset(this.model.init_name_lavel)) {
            return this.validationInputsRequired(`init_name_lavel`);
          }

          for (let i = 0; i < this.model.level_number; i++) {
            if (!isset(this.model.name_level[i])) {
              return this.validationInputsRequired(`name_level${i}`);
            }
            if (!isset(this.model.number_level[i])) {
              return this.validationInputsRequired(`number_level${i}`);
            }
          }
          this.$emit('fillDiseaseForm', 'secondStep');

          return res;
        })
        .then((responseSelects) => {
          if (!responseSelects) return responseSelects;
          if (!isset(elThis.model.catch_type)) {
            return this.validationInputsRequired('disease');
          } else return true;
        });
    },
  },

  created() {
    this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.lengthInitial = editForm.disease_statuses.length - 1;
      this.model.catch_type = editForm.catch_type;
      this.model.init_level = 0;
      this.model.id = editForm.id;
      this.model.symptoms_number = editForm.disease_symptoms.length;
      this.model.symptom_names = [];
      this.model.symptom_ids = [];

      editForm.disease_symptoms.forEach((element) => {
        this.model.symptom_names.push(element.disease_symptom);
        this.model.symptom_ids.push(element.id);
      });

      if (editForm.disease_statuses.length > 0) {
        this.model.init_name_lavel =
          editForm.disease_statuses[0].disease_status;

        editForm.disease_statuses.shift();
        this.model.level_number = editForm.disease_statuses.length;
        editForm.disease_statuses.forEach((element) => {
          this.model.number_level.push(element.state_number);
          this.model.name_level.push(element.disease_status);
          this.model.disabled.push(element.editable);
          if (element.image) {
            let splited = element.image.split('/');
            this.model.fileList.push([{ name: splited[splited.length - 1] }]);
          } else {
            this.model.fileList.push([]);
          }
        });
      }
    }
  },
};
</script>
<style scoped>
.upload-image-level {
  /* margin-top: 35px; */
  margin-bottom: 17px;
  padding-top: 0px;
}
</style>
